import React, { useState, useEffect } from 'react'

function isDaytime() {
  const hour = new Date().getHours()
  return hour >= 6 && hour < 18
}

function getInitialDark() {
  // Only honour a saved theme if the user explicitly chose it
  if (localStorage.getItem('theme-source') === 'manual') {
    return localStorage.getItem('theme') === 'dark'
  }
  return !isDaytime()
}

export default function ThemeToggle() {
  const [dark, setDark] = useState(getInitialDark)

  // Apply class whenever dark changes
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark)
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }, [dark])

  // Auto-switch every minute if no manual override
  useEffect(() => {
    const id = setInterval(() => {
      if (localStorage.getItem('theme-source') !== 'manual') {
        setDark(!isDaytime())
      }
    }, 60 * 1000)
    return () => clearInterval(id)
  }, [])

  function handleToggle() {
    localStorage.setItem('theme-source', 'manual')
    setDark(d => !d)
  }

  return (
    <button
      onClick={handleToggle}
      aria-label="Toggle theme"
      className="fixed top-4 right-4 z-50 w-9 h-9 flex items-center justify-center
                 rounded-lg border border-card-border bg-card-bg text-muted
                 hover:text-title transition-colors shadow-sm"
    >
      <i className={dark ? 'ri-sun-line text-base' : 'ri-moon-line text-base'}></i>
    </button>
  )
}
